export enum ActivityType {
  QualificationUpdated = 77,
  QualificationSendMessageAO = 78,
  QualificationSendMessageRegulator = 79,
  QualificationApprovedCcea = 80,
  QualificationApprovedOfqual = 81,
  QualificationRejectedCcea = 82,
  QualificationRejectedOfqual = 83,
  QualificationResubmitted = 84,
}
